import React, { useEffect, useState } from "react";
import { getSmartQuestionaireList, deleteSmartQuestionaire, sendSmartQuestionaire } from "../../../../services/CommonService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../SmartQuestionaire.css";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import DeleteSmartQuestionaireSleeve from './deleteSmartQuestionaireSleeve';

function ManageSmartQuestionaire() {
  const [loading, setLoading] = useState(false);
  const [questionaires, setQuestionaires] = useState([]);
  // const [dropdownVisible, setDropdownVisible] = useState(null); // Dropdown visibility not needed for rc-dropdown
  const [deleteModal, setDeleteModal] = useState({ show: false, id: null, name: '', uuid: null });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10); // Items per page
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchList(currentPage);
  }, [currentPage]);

  const fetchList = (page = 1) => {
    setLoading(true);
    getSmartQuestionaireList({ page, limit: pageSize })
      .then((res) => {
        setQuestionaires(res.data.data || []);
        setTotalItems(res.data.total || 0); // API should return total count
        setLoading(false);
      })
      .catch(() => {
        setQuestionaires([]);
        setTotalItems(0);
        setLoading(false);
      });
  };

  const handleDelete = (item) => {
    console.log("Delete clicked for:", item); // Debug log
    setDeleteModal({ show: true, id: item.sleeve_id, name: item.sleeve_name, uuid: item.sleeve_uuid });
    // setDropdownVisible(null); // Not needed
  };

  const confirmDelete = () => {
    if (!deleteModal.uuid) return;
    setLoading(true);
    deleteSmartQuestionaire({ sleeve_uuid: deleteModal.uuid })
      .then((res) => {
        toast.success(res.data.message || "Deleted successfully");
        setDeleteModal({ show: false, id: null, name: '', uuid: null });
        setLoading(false);
        fetchList();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Delete failed");
        setLoading(false);
      });
  };

  const handleNavigateToDetail = (sleeve_uuid, status) => {
    if (status === 1) {
      navigate(`/client-portal/smart-questionnaire/${sleeve_uuid}/step/2`);
    } else {
      navigate(`/client-portal/smart-questionnaire/manage/${sleeve_uuid}`);
    }
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}

      <div className="section-bg-color" style={{ minHeight: 'calc(100vh - 54.5px)' }}>
        <div className="container py-4">
          <div className="d-flex align-items-center justify-content-between mb-4 manage-sq-detail" >
            <h2 className="mb-0 text-white">Manage Smart Questionnaire</h2>
            <button
              className="btn btn-light"
              onClick={() => navigate('/client-portal')}
              style={{ display: 'inline-flex', alignItems: 'center' }}
            >
              <i className="bi bi-arrow-left me-2"></i> Back
            </button>
          </div>
          <div className="sq-card p-0 table-responsive">
            <table className="sq-table w-100">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Created</th>
                  <th>Due Date</th>
                  <th>Recipients</th>
                  <th>Status</th> {/* New Status column */}
                  <th className="table-header-center">Manage</th>
                  <th className="table-header-center"><i className="bi bi-three-dots-vertical" /></th>
                </tr>
              </thead>
              <tbody>
                {questionaires.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">No data found.</td>
                  </tr>
                ) : (
                  questionaires.map((q, idx) => {
                    // Dropdown menu for each row
                    const menu = (
                      <Menu
                        className="custom-rc-dropdown-menu"
                        onClick={({ key }) => {
                          if (key === 'delete') handleDelete(q);
                        }}
                      >
                        <MenuItem key="delete" className="custom-rc-dropdown-item custom-rc-dropdown-delete">
                          <i className="bi bi-trash me-1"></i>Delete
                        </MenuItem>
                      </Menu>
                    );
                    return (
                      <tr
                        key={q.sleeve_id}
                        style={idx !== questionaires.length - 1 ? { borderBottom: '1px solid #dee2e6' } : {}}
                      >
                        <td>{idx + 1}</td>
                        <td>{q.sleeve_name}</td>
                        <td>{q.created_at ? new Date(q.created_at).toLocaleDateString() : '-'}</td>
                        <td>{q.due_date ? new Date(q.due_date).toLocaleDateString() : '-'}</td>
                        <td>
                          {q.recipients && q.recipients.length > 0 ? (
                            <span className="sq-badge">
                              {q.recipients.length === 1 ? (
                                <span className="bi bi-person" style={{ fontSize: 16, marginRight: 4 }}></span>
                              ) : (
                                <span className="bi bi-people" style={{ fontSize: 16, marginRight: 4 }}></span>
                              )}
                              {q.recipients.length} recipient{q.recipients.length > 1 ? 's' : ''}
                            </span>
                          ) : '-'}
                        </td>
                        {/* Status badge */}
                        <td>
                          {q.status === 1 && (
                            <span className="badge bg-secondary">Draft</span>
                          )}
                          {q.status === 2 && (
                            <span className="badge bg-warning text-dark">In Progress</span>
                          )}
                          {q.status === 3 && (
                            <span className="badge bg-success">Complete</span>
                          )}
                        </td>
                        <td className="table-header-center">
                          <button
                            className="btn btn-primary btn-sm px-3"
                            onClick={() => handleNavigateToDetail(q.sleeve_uuid, q.status)}
                            style={{ fontWeight: 500 }}
                          >
                            Manage
                          </button>
                        </td>
                        <td className="table-header-center">
                          <Dropdown
                            trigger={["click"]}
                            overlay={menu}
                            animation="slide-up"
                            placement="bottomRight"
                          >
                            <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', height: '32px' }}>
                              <i className="bi bi-three-dots-vertical" style={{ fontSize: 20 }}></i>
                            </span>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          {/* Pagination Controls */}
          <div className="d-flex justify-content-end mt-3">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>&laquo;</button>
                </li>
                {Array.from({ length: Math.ceil(totalItems / pageSize) }, (_, i) => (
                  <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === Math.ceil(totalItems / pageSize) || totalItems === 0 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === Math.ceil(totalItems / pageSize) || totalItems === 0}>&raquo;</button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        {/* Delete Confirmation Modal */}
        <DeleteSmartQuestionaireSleeve
          show={deleteModal.show}
          name={deleteModal.name}
          deleting={loading}
          onCancel={() => setDeleteModal({ show: false, id: null, name: '', uuid: null })}
          onDelete={confirmDelete}
        />
      </div>
    </>
  );
}

export default ManageSmartQuestionaire; 